import View from './view';
export const PollVoteResultModal = View;
